module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan3-2-f5e80325da998c8320092b66e6becc06.webp";